import { AxiosInstance } from 'axios';

import * as types from '../../../../../../typings/api/skymap/rest/v1/profile';

export class ProfileServiceV1 implements types.Handlers {
  constructor(private axios: AxiosInstance) {}

  async getRequestingUserProfile(
    params: types.GetRequestingUserProfileParameters,
  ): Promise<types.UserProfileResponse> {
    const { data } = await this.axios.get<types.UserProfileResponse>(`/v1/profile/`);
    return data;
  }

  async deleteActiveSsoConnection(
    params: types.DeleteActiveSsoConnectionParameters,
  ): Promise<void> {
    await this.axios.delete(`/v1/profile/sso`, { data: params.body });
  }
}
